import { inject as injectBranding } from '@angular/core';
import { SiteBrandingService } from '../../services/site-branding.service';
import {
  ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import {
  DonationRequest,
  DonationsService
} from '../../services/donations.service';

import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-donations',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './donations.component.html',
  styleUrls: [
    './donations.component.css'
  ]
})
export class DonationsComponent {
  readonly branding = injectBranding(SiteBrandingService);

  isSubmitting = false;

  donationRequest: DonationRequest =
    this.createEmptyRequest();

  constructor(
    private readonly donationsService:
      DonationsService,
    private readonly toastService:
      ToastService,
  private readonly cdr:
    ChangeDetectorRef
  ) {}


  submitDonationRequest(): void {

  if (!this.isFormValid()) {
    this.toastService.error(
      'Enter all required fields.'
    );

    return;
  }

  this.isSubmitting = true;

  this.donationsService
    .submitDonationRequest(
      this.donationRequest
    )
    .subscribe({

      next: () => {

        this.isSubmitting = false;

        this.donationRequest =
          this.createEmptyRequest();

        this.toastService.success(
          'Donation request submitted successfully.'
        );

        this.cdr.detectChanges();
      },

      error: error => {

        this.isSubmitting = false;

        const message =
          typeof error.error === 'string'
            ? error.error
            : error.error?.message ??
              'Unable to submit your donation request.';

        this.toastService.error(
          message
        );

        this.cdr.detectChanges();
      }

    });
}

  private isFormValid(): boolean {

    return Boolean(
      this.donationRequest.organizationName.trim() &&
      this.donationRequest.contactName.trim() &&
      this.donationRequest.email.trim() &&
      this.donationRequest.eventName.trim()
    );
  }


  private createEmptyRequest():
    DonationRequest {

    return {
      organizationName: '',
      contactName: '',
      contactTitle: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      eventName: '',
      eventDate: null,
      donationNeededBy: null,
      donationType: '',
      requestedAmountOrItems: '',
      additionalInformation: ''
    };
  }

}
